import LFOTrack from './LFOTrack.js';
import {setLFOPatternLocks} from 'actions/index.js';
import {moveKey, deleteKey} from 'utils/objectMover.js';

class LFOsTrack {
    constructor(sequencerEngine, subSequence) {
        this.sequencerEngine = sequencerEngine;
        this.subSequence = subSequence;
        this.store = sequencerEngine.store;
        this.lfos = [];
        this.lfos = getLFOTracks(sequencerEngine, this);
        this.currentPattern = 0;
    }

    switchToPattern(currentPattern, i) {
        this.currentPattern = i;
        return this.updateRedux(currentPattern, i);
    }

    updateRedux(currentPattern, newPattern) {
        let parameters = this.getAllPatternLockedParameters(currentPattern, newPattern);
        let bulkUpdate = [];
        for (let i in parameters) {
            let parameter = parameters[i];
            let update = parameter.updateRedux(true);
            if (update !== undefined) {
                bulkUpdate[update.id] = update.value;
            }
        }
        return bulkUpdate;
    }

    get patternLocks() {
        let locks = this.store.getState().tracks.lfoPatternLocks[this.subSequence.id] || {};
        return {... locks};
    }

    deletePattern(i) {
        let patternLocks = this.patternLocks;
        this.store.dispatch(setLFOPatternLocks(
            this.subSequence.id,
            deleteKey(i, patternLocks)));
    }

    movePatternTo(from, to) {
        let patternLocks = this.patternLocks;
        this.store.dispatch(setLFOPatternLocks(
            this.subSequence.id,
            moveKey(from, to, patternLocks)));
    }

    getAllPatternLockedParameters(currentPattern, newPattern) {
        let parameters = [];
        this.lfos.forEach(
            lfo =>
                lfo.lfo.parameters
                .filter(parameter => parameter.hasPatternLockedValues(currentPattern, newPattern))
                .forEach(parameter => parameters.push(parameter)));
        return parameters;
    }

    newPattern(numOfPatterns) {
        let newPatternNumber = numOfPatterns - 1;
        this.getAllPatternLockedParameters()
            .forEach(parameter => parameter.newPattern(this.currentPattern, newPatternNumber));
            
        let patternLocks = this.patternLocks;
        patternLocks[newPatternNumber] = this.patternLocked;
        this.store.dispatch(setLFOPatternLocks(
            this.subSequence.id,
            patternLocks));
    }

    get patternLocked() {
        return this.patternLocks[this.currentPattern] || false;
    }

    set patternLocked(locked) {
        let patternLocks = this.patternLocks;

        patternLocks[this.currentPattern] = locked;
        this.store.dispatch(setLFOPatternLocks(
            this.subSequence.id,
            patternLocks));
        this.updateRedux();
    }

    togglePatternLocked() {
        this.patternLocked = !this.patternLocked;
    }

    start(time) {
        for (let i in this.lfos) {
            let lfo = this.lfos[i];
            lfo.start(time);
        }
    }

    stop() {
        for (let i in this.lfos) {
            let lfo = this.lfos[i];
            lfo.stop();
        }
    }


    onBPMUpdated() {
        this.lfos.forEach(lfo => lfo.lfo.onBPMUpdated());
    }
}

function getLFOTracks(sequencerEngine, lfosTrack) {
    let lfos = [];
    lfos.push(new LFOTrack(sequencerEngine, lfosTrack, sequencerEngine.mixSession, 1));
    lfos.push(new LFOTrack(sequencerEngine, lfosTrack, sequencerEngine.mixSession, 2));
    lfos.push(new LFOTrack(sequencerEngine, lfosTrack, sequencerEngine.mixSession, 3));
    lfos.push(new LFOTrack(sequencerEngine, lfosTrack, sequencerEngine.mixSession, 4));
    return lfos;
}

export default LFOsTrack;
